module.exports = __webpack_public_path__ + "img/Group 11413@2x.d4af28aa.png";